/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description accounts search fields meta
 */
import _ from 'lodash';
import { SORT_COLUMN_LABELS } from '@veritable/common/constants';

const SEARCH_FIELDS_META = {
	accountNumber: {
		label: 'Account ID',
		placeholder: 'E.g.: 123456789',
	},
	accountAge: {
		label: 'Age (Days)',
		placeholder: 'E.g.: 30',
	},
	guarantorName: {
		label: 'Guarantor Name',
		placeholder: 'E.g.: Jane Doe',
	},
	patientName: {
		label: 'Patient Name',
		placeholder: 'E.g.: John Doe',
	},
	patientMRN: {
		label: 'Patient MRN',
		placeholder: 'E.g.: MRN123456',
	},
	patientIdentifier: {
		label: 'Patient ID',
		placeholder: 'Enter Member ID, MRN, SSN, etc.',
	},
	accountReceivable: {
		label: 'Account Receivable',
		placeholder: 'E.g.: 500',
	},
	pendingPatientResponsibility: {
		label: 'Pending PR',
		placeholder: 'E.g.: 500',
	},
	billedAmount: {
		label: 'Billed Amount',
		placeholder: 'E.g.: 500',
	},
};

const ACCOUNTS_SORT_COLUMNS: Record<
	'accountAge' | 'accountReceivable' | 'patientResponsibility' | 'pendingPatientResponsibility',
	Accounts.IAccountSortColumn
> = {
	accountAge: 'accountAge',
	accountReceivable: 'accountReceivable',
	patientResponsibility: 'patientResponsibility',
	pendingPatientResponsibility: 'pendingPatientResponsibility',
};

// default sort options for the sort table data
const ACCOUNTS_SORT_COLUMN_DEFAULT_OPTIONS = [
	{
		apikey: ACCOUNTS_SORT_COLUMNS.accountAge,
		asc: true,
		label: `Age (${SORT_COLUMN_LABELS.oldToNew})`,
	},
	{
		apikey: ACCOUNTS_SORT_COLUMNS.accountReceivable,
		asc: false,
		label: `Account Receivable (${SORT_COLUMN_LABELS.highToLow})`,
	},
	{
		apikey: ACCOUNTS_SORT_COLUMNS.patientResponsibility,
		asc: false,
		label: `PR (${SORT_COLUMN_LABELS.highToLow})`,
	},
	{
		apikey: ACCOUNTS_SORT_COLUMNS.pendingPatientResponsibility,
		asc: false,
		label: `Pending PR (${SORT_COLUMN_LABELS.highToLow})`,
	},
];

// options for the sort table data
const ACCOUNTS_SORT_COLUMN_OPTIONS: SortItemType[] = _.map(ACCOUNTS_SORT_COLUMN_DEFAULT_OPTIONS, (option) => ({
	...option,
	key: option.label,
}));

export { SEARCH_FIELDS_META, ACCOUNTS_SORT_COLUMNS, ACCOUNTS_SORT_COLUMN_OPTIONS };
